import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BusinessModeCustomEditor from './BusinessModeCustomEditor';
import BusinessModeFieldsPanel from './BusinessModeFieldsPanel';
import { MODE_CARDS } from './model/constants';
import useBusinessMode from './model/useBusinessMode';

const BusinessMode = () => {
    const { t } = useTranslation(['Settings']);
    const {
        selectedMode,
        activeFields,
        isSaving,
        showCustomEditor,
        setShowCustomEditor,
        customEditorTab,
        setCustomEditorTab,
        customEditorValue,
        setCustomEditorValue,
        handleSelectMode,
        handleSaveMode,
        handleOpenCustomEditor,
        handleApplyCustomEditor,
        handleCopyActiveStructure,
    } = useBusinessMode();

    return (
        <Row>
            <Col sm={12}>
                <div className="w-100 d-flex pt-1 justify-content-between align-items-start mb-3 mb-md-2">
                    <div className="pb-1">
                        <h4 className="p-0 m-0">{t('businessMode.title')}</h4>
                        <small className="text-muted">{t('businessMode.subtitle')}</small>
                    </div>
                    <div className="page-toolbar-actions mt-2 mt-md-0">
                        <Badge bg="light" text="dark" className="fw-semibold">
                            {t(`businessMode.options.${selectedMode}.name`)}
                        </Badge>
                    </div>
                </div>
                <Card>
                    <Card.Body>
                        <Row className="g-3">
                            {MODE_CARDS.map(({ value, Icon }) => {
                                const isActive = selectedMode === value;
                                return (
                                    <Col key={value} xs={12} md={6} lg={4}>
                                        <Card
                                            role="button"
                                            onClick={() => handleSelectMode(value)}
                                            className={`h-100 border ${isActive ? 'border-primary shadow-sm' : 'border-light-subtle'} ${isSaving ? 'pe-none opacity-75' : ''}`}
                                        >
                                            <Card.Body className="d-flex gap-3 align-items-start">
                                                <div
                                                    className={`rounded d-inline-flex align-items-center justify-content-center ${
                                                        isActive ? 'text-primary bg-light-primary' : 'text-muted bg-light'
                                                    }`}
                                                    style={{ width: '42px', height: '42px', minWidth: '42px' }}
                                                >
                                                    <Icon width="22" height="22" />
                                                </div>
                                                <div className="overflow-hidden">
                                                    <h6 className="mb-1 text-truncate">
                                                        {t(`businessMode.options.${value}.name`)}
                                                    </h6>
                                                    <p className="mb-0 text-muted fs-12">
                                                        {t(`businessMode.options.${value}.description`)}
                                                    </p>
                                                    {value === 'custom' ? (
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            className="p-0 mt-1 text-decoration-none d-block text-start"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOpenCustomEditor();
                                                            }}
                                                        >
                                                            {t('businessMode.configureCustomForm')}
                                                        </Button>
                                                    ) : null}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>

                        <BusinessModeFieldsPanel
                            fields={activeFields}
                            isSaving={isSaving}
                            onSave={handleSaveMode}
                            onCopyStructure={handleCopyActiveStructure}
                        />
                    </Card.Body>
                </Card>
            </Col>

            <BusinessModeCustomEditor
                show={showCustomEditor}
                tab={customEditorTab}
                value={customEditorValue}
                onHide={() => setShowCustomEditor(false)}
                onTabChange={setCustomEditorTab}
                onValueChange={setCustomEditorValue}
                onApply={handleApplyCustomEditor}
            />
        </Row>
    );
};

export default BusinessMode;
